/* Global utility functions.
 *
 * @file combined
 */

/* Scroll event listener with request animation frame throttling
 * use this instead of the native scroll listener
 * pass a function to this scroll listener
 */
export function scrollListener(myscrollFunction) {
    // Setup a timer
    let timeout;
    // Listen for resize events
    window.addEventListener(
        "scroll",
        function(event) {
            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function() {
                // Run our scroll functions (Your code here)
                myscrollFunction(event);
            });
        },
        false
    );
}

/* Resize event listener with request animation frame throttling
 * use this instead of the native resize listener
 * pass a function to this resize listener
 */
export function resizeListener(myresizeFunction) {
    // Setup a timer
    let timeout;
    // Listen for resize events
    window.addEventListener(
        "resize",
        function(event) {
            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function() {
                // Run our resize functions (Your code here)
                myresizeFunction(event);
            });
        },
        false
    );
}

/*
 *  IE 11 polyfill for ForEach loop.
 */
export function ie11forEachPolyfill() {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function(callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
}

/*
 *  Check if an element exisits
 */
export function elementExists(element) {
    return typeof element !== "undefined" && element != null;
}

/*
 *  Slide Element Up
 */
const slideWatchers = {};
export function slideUp(target, duration = 500, callback) {
    clearTimeout(slideWatchers[target.id]);
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    slideWatchers[target.id] = setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");

        if (callback instanceof Function) {
            callback();
        }
    }, duration);
}

/*
 *  Slide Element Down
 */
export function slideDown(target, duration = 500, callback) {
    clearTimeout(slideWatchers[target.id]);
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    slideWatchers[target.id] = setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");

        if (callback instanceof Function) {
            callback();
        }
    }, duration);
}

/*
 *  Slide Toggle Element
 */
export function slideToggle(target, duration = 500, callback) {
    if (window.getComputedStyle(target).display === "none") {
        return slideDown(target, duration, callback);
    } else {
        return slideUp(target, duration, callback);
    }
}

// Load any scripts Asynchronous.
export function loadScriptAsync(uri) {
    return new Promise((resolve, reject) => {
        const tag = document.createElement("script");
        tag.src = uri;
        tag.async = true;
        tag.onload = () => {
            resolve();
        };
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

// To detect if the  borwser is IE or not.
export const isIE = () =>
    !!window.MSInputMethodContext && !!document.documentMode;

/**
 * This function is fot Accordion Toggle block.
 * It's moved here from block level in somecase we need to trigger from different block.
 * @param {array} toggleButtons
 */
export const toggleHandler = toggleButtons => {
    // Loop through buttons
    Array.from(toggleButtons).forEach(toggleButton => {
        // Add click event.
        toggleButton.addEventListener("click", function() {
            //Find parent's previous element
            const accordion = this.parentNode.previousElementSibling;
            let buttonText = this.children[1];

            let isOpen = accordion.classList.contains(
                "block-accordion-toggle__items--open"
            );

            if (isOpen) {
                this.classList.remove("a-toggle-button--open");
                accordion.classList.remove(
                    "block-accordion-toggle__items--open"
                );
                buttonText.innerText = this.dataset.open;
            } else {
                this.classList.add("a-toggle-button--open");
                accordion.classList.add("block-accordion-toggle__items--open");
                buttonText.innerText = this.dataset.close;
            }
        });
    });
};
